<template>
  <fragment>
    <div class="row" v-if="entity">
      <div class="col-lg-12 col-xl-3">
        <div class="card m-b-30">
          <div class="card-body">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-product-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link mb-2 active"
                id="v-pills-general-tab"
                data-toggle="pill"
                href="#v-pills-general"
                role="tab"
                aria-controls="v-pills-general"
                aria-selected="true"
              >
                <i class="feather icon-info mr-2"></i>Generale
              </a>
              <a v-if="$store.getters.isInRole('company-bankinformation')"
                class="nav-link mb-2"
                id="v-pills-bank-tab"
                data-toggle="pill"
                href="#v-pills-bank"
                role="tab"
                aria-controls="v-pills-bank"
                aria-selected="false"
              >
                <i class="feather icon-dollar-sign mr-2"></i>Informazioni Bancarie
              </a>
              <a
               v-if="$store.getters.isInRole('company-extendedinfo')"
                class="nav-link mb-2"
                id="v-pills-bo-tab"
                data-toggle="pill"
                href="#v-pills-bo"
                role="tab"
                aria-controls="v-pills-bo"
                aria-selected="false"
              >
                <i class="feather icon-external-link mr-2"></i>Informazioni estese
              </a>
               <a
                 v-if="$store.getters.isInRole('company-orders')"
                class="nav-link mb-2"
                id="v-pills-orders-tab"
                data-toggle="pill"
                href="#v-pills-orders"
                role="tab"
                aria-controls="v-pills-orders"
                aria-selected="false"
              >
                <i class="feather icon-shopping-cart mr-2"></i>Ordini
              </a>
                    <a
                      v-if="$store.getters.isInRole('company-mails-list')"
                class="nav-link mb-2"
                id="v-pills-emails-tab"
                data-toggle="pill"
                href="#v-pills-emails"
                role="tab"
                aria-controls="v-pills-emails"
                aria-selected="false"
              >
                <i class="feather icon-mail mr-2"></i>Comunicazioni
              </a>
              <a
               v-if="$store.getters.isInRole('company-note-list')"
                class="nav-link mb-2"
                id="v-pills-note-tab"
                data-toggle="pill"
                href="#v-pills-note"
                role="tab"
                aria-controls="v-pills-note"
                aria-selected="false"
              >
                <i class="feather icon-edit-1 mr-2"></i>Note
              </a>
              <a
               v-if="$store.getters.isInRole('company-attachment-list')"
                class="nav-link mb-2"
                id="v-pills-attachments-tab"
                data-toggle="pill"
                href="#v-pills-attachments"
                role="tab"
                aria-controls="v-pills-note"
                aria-selected="false"
              >
                <i class="feather icon-download mr-2"></i>Allegati
              </a>
              <a
                v-if="$store.getters.isInRole('company-calls')"
                class="nav-link mb-2"
                id="v-pills-call-tab"
                data-toggle="pill"
                href="#v-pills-call"
                role="tab"
                aria-controls="v-pills-call"
                aria-selected="false"
              >
                <i class="feather icon-phone mr-2"></i>Chiamate
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-9">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
                <!-- generale -->
                <div id="baseinformation" v-if="entity">
                  <div class="row">
                    <taglist v-model="entity.tags" :readOnlyReserved="true" :exclude="['allegati']"></taglist>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <ValidationProvider
                          v-slot="{ classes, errors }"
                          immediate
                          slim
                          rules="required"
                        >
                          <label class="col-form-label" for="internalCode">Codice interno</label>
                          <input
                            type="text"
                            class="form-control required"
                            :readonly="inputReadOnly"
                            id="internalCode"
                            name="internalCode"
                            placeholder="Codice interno"
                            v-model="entity.internalCode"
                            :class="classes"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <!--<form @submit.prevent="save" v-if="entity">-->
                    <div class="col-12">
                      <div class="form-group">
                        <ValidationProvider
                          v-slot="{ classes, errors }"
                          immediate
                          slim
                          rules="required"
                        >
                          <label class="col-form-label" for="name">Ragione sociale</label>
                          <input
                            :readonly="inputReadOnly"
                            type="text"
                            class="form-control required"
                            id="name"
                            name="name"
                           
                            v-model="entity.name"
                            :class="classes"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="col-form-label" for="fiscalCode">Codice Fiscale</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          id="fiscalCode"
                          name="fiscalCode"
                         
                          maxlength="16"
                          v-model="entity.fiscalCode"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="col-form-label" for="vatNumber">Partita IVA</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          id="vatNumber"
                          name="vatNumber"
                        
                          maxlength="11"
                          v-model="entity.vatNumber"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="col-form-label" for="rea">R.E.A</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          id="rea"
                          name="rea"
                        
                          maxlength="200"
                          v-model="entity.rea"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="col-form-label" for="sdi">SDI</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          id="sdi"
                          name="sdi"
                        
                          maxlength="200"
                          v-model="entity.sdi"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                     <div class="col-12">
                       <h5 class="page-title">Persona di riferimento</h5>
                      
                     </div>
                    <div class="col-4">
                       <div class="form-group">
                        <label class="col-form-label" for="personName">Nome</label>
                        <input
                          :readonly="!$store.getters.isInRole('company-edit')"
                          type="text"
                          class="form-control"
                          id="personName"
                          name="personName"
                        
                          maxlength="150"
                          v-model="entity.personName"
                        />
                      </div>
                    </div>
                    <div class="col-4">
                       <div class="form-group">
                        <label class="col-form-label" for="personSurname">Cognome</label>
                        <input
                          :readonly="!$store.getters.isInRole('company-edit')"
                          type="text"
                          class="form-control"
                          id="personSurname"
                          name="personSurname"
                        
                          maxlength="150"
                          v-model="entity.personSurname"
                        />
                      </div>
                    </div>
                    <div class="col-4">
                       <div class="form-group">
                        <label class="col-form-label" for="personAddress">Incarico</label>
                        <input
                          :readonly="!$store.getters.isInRole('company-edit')"
                          type="text"
                          class="form-control"
                          id="personAddress"
                          name="personAddress"
                        
                          maxlength="150"
                          v-model="entity.personAddress"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                   
                    <email-address-list v-model="entity.emails" :readonly="!$store.getters.isInRole('company-edit')"></email-address-list>
                  </div>
                  <div class="row">
                    <phonelist v-model="entity.phones" :readonly="!$store.getters.isInRole('company-edit')"></phonelist>
                  </div>
                  <div class="row">
                   
                    <websitelist v-model="entity.webSites" :readOnly="!$store.getters.isInRole('company-edit')"></websitelist>
                  </div>
                  <div class="row">
                    <faxlist v-model="entity.faxes" :readonly="!$store.getters.isInRole('company-edit')"></faxlist>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label" for="address">Indirizzo</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          id="address"
                          placeholder="Indirizzo"
                          v-model="entity.address"
                        />
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label class="col-form-label" for="city">Citt&agrave;</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          name="city"
                          id="city"
                          placeholder="Città"
                          v-model="entity.city"
                        />
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label class="col-form-label" for="zipCode">CAP</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          name="zipCode"
                          id="zipCode"
                          placeholder="CAP"
                          v-model="entity.zipCode"
                        />
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label class="col-form-label" for="district">Provincia</label>
                        <input
                          :readonly="inputReadOnly"
                          type="text"
                          class="form-control"
                          name="district"
                          id="district"
                          placeholder="provincia"
                          v-model="entity.district"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <gmap
                        v-if="entity"
                        :value="entity"
                        :addressProperties="['address','city','zipCode','district']"
                      ></gmap>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                    <div class="form-group mt-3">
                      <button type="button" class="btn btn-xs btn-primary-rgba mr-2" v-on:click="save" v-if="$store.getters.isInRole('company-edit')">
                        Salva
                        <font-awesome-icon :icon="['far','save']"></font-awesome-icon>
                      </button>
                      <button type="button" class="btn btn-xs btn-danger-rgba mr-2" v-on:click="cancel">
                        Annulla
                        <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon>
                      </button>
                    </div>
                    </div>
                    <!--</form>-->
                  </div>
                </div>
              </div>
               <div
                class="tab-pane fade"
                id="v-pills-sendemail"
                role="tabpanel"
                aria-labelledby="v-pills-sendemail-tab"
              >
                <div class="card m-b-30">
                                <div class="card-header">
                                    <h5 class="card-title">Invia nuovo messaggio</h5>
                                </div>
                                <div class="card-body">                                    
                                    <form v-if="communication">
                                       <div class="form-group row text-right">
                                            <div class="col-sm-12">
                                               <button  type="button" class="btn btn-primary-rgba mr-2" @click="sendCommunication"><i class="feather icon-send mr-2"></i>Invia</button>
                                                <button  type="button" class="btn btn-danger-rgba mr-2"  @click="cancelCommunication"><i class="feather icon-trash mr-2"></i>Annulla</button>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="emailTo" class="col-sm-2 col-form-label">A</label>
                                            <div class="col-sm-10">
                                               {{communication.to}}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="emailCc" class="col-sm-2 col-form-label">CC</label>
                                            <div class="col-sm-10">
                                                <input type="text" v-model="communication.cc" class="form-control" id="emailCc" placeholder="Elenco mail separati da ';'">
                                            </div>
                                        </div>
                                        
                                        <div class="form-group row">
                                            <label for="emailSubject" class="col-sm-2 col-form-label">Oggetto</label>
                                            <div class="col-sm-10">
                                                <input type="text" v-model="communication.subject" class="form-control" id="emailSubject" placeholder="Oggetto">
                                            </div>
                                        </div>                                      
                                        <div class="form-group row">
                                            <label for="emailSubject" class="col-sm-2 col-form-label">Messaggio</label>
                                            <div class="col-sm-10">
                                               <editor
                          
                          :api-key="tinyKey"
                          :init="{
                             convert_urls: false,
                             remove_script_host: false,
                            height: 500,
                            menubar: false,
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code fullscreen',
                              'insertdatetime media table paste code help wordcount',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code',
                          }"
                          v-model="communication.body"
                          model-events="change paste"
                        ></editor>
                                            </div>

                                            
                                        </div>
                                         <div class="form-group row">
                                            <label for="emailSubject" class="col-sm-2 col-form-label">Allegati</label>
                                            <div class="col-sm-10">
                                                        <attachments  :value="communication.entityId" entityType="none"  />
                                            </div>
                                         </div>
                                        <div class="form-group row text-right">
                                            <div class="col-sm-12">
                                                <button  type="button" class="btn btn-primary-rgba mr-2" @click="sendCommunication"><i class="feather icon-send mr-2"></i>Invia</button>
                                                <button  type="button" class="btn btn-danger-rgba mr-2"  @click="cancelCommunication"><i class="feather icon-trash mr-2"></i>Annulla</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-bo"
                role="tabpanel"
                aria-labelledby="v-pills-bo-tab"
              >
                <oneinformation :value="entity.companyId" />
              </div>

               <div
                class="tab-pane fade"
                id="v-pills-orders"
                role="tabpanel"
                aria-labelledby="v-pills-orders-tab"
              >
                <orderList v-if="entity" :value="entity.companyId" channel="terservice" channelDescription ="Abbonamenti Cartacei"></orderList>
                <orderList  v-if="entity"  :value="entity.companyId" :channel="'vnp'" :channelDescription ="'Edicola digitale'" ></orderList>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-bank"
                role="tabpanel"
                aria-labelledby="v-pills-bank-tab"
              >
                <bankinformation :value="entity.companyId" />
              </div>

                  <div
                class="tab-pane fade"
                id="v-pills-emails"
                role="tabpanel"
                aria-labelledby="v-pills-emails-tab"
              >
                <mailmessagelist :value="entity.companyId"  />
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-note"
                role="tabpanel"
                aria-labelledby="v-pills-note-tab"
              >
               <notelist :value="entity.companyId"/>
              </div>

              <div
                class="tab-pane fade"
                id="v-pills-attachments"
                role="tabpanel"
                aria-labelledby="v-pills-attachments-tab"
              >
                <attachments  :value="entity.companyId" :readOnly="!$store.getters.isInRole('company-attachment-edit')" />
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-call"
                role="tabpanel"
                aria-labelledby="v-pills-call-tab"
              >
               <callList :value="entity.companyId" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import { Slider } from "vue-color";
export default {
  data() {
    return {
      entity: null,
      email:null,
      subject:"",
      cc:"",
      body:"",
      attachments:[],
      communication: null
    };
  },
  computed: {
    tagTypes: function () {
      return this.$store.state.tagTypes;
    },
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
    inputReadOnly:function() {
      if(this.entity)
      return this.entity.isImported;
      return true;
    }
  },
  components: {
    Editor,
    "chrome-picker": Chrome,
  },
  name: "CompanySave",
  beforeMount() {
    var me = this;

    axios
      .get(
        "company/" + me.$route.params.id ||
          "00000000-0000-0000-0000-000000000000"
      )
      .then((response) => {
        me.entity = response.data;
        if(me.entity.name!="")
        me.$store.state.breadCrump.title =`${me.entity.name} - [${me.entity.internalCode}]`;
      });
  },
  methods: {

sendCommunication(){
  var me = this;
if(this.communication.subject == ""){
   me.$swal({
          title: "Inserisci un oggetto",
          text: "",
          type: "error",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });
return;

}

axios.post('newsletter/SendCommunication',this.communication).then((response)=>{
 
me.cancelCommunication();

})

},
cancelCommunication(){
 $('.tab-pane').removeClass("show");
$('.tab-pane').removeClass("active");
$('#v-pills-general').addClass("show active");
me.communication = null;

},
sendEmail(email){

var me = this;
  axios.get('newsletter/communication').then((response) =>{
me.communication = response.data;
me.communication.to = email.email;
me.communication.companyId = me.entity.companyId;
$('.tab-pane').removeClass("show");
$('.tab-pane').removeClass("active");
$('#v-pills-sendemail').addClass("show active");
  })


},


    showTabs(tab) {
      $(".tabs .card").addClass("d-none");
      $("#" + tab).removeClass("d-none");
    },
    cancel() {
      this.$router.push({
        name: "route-company-list",

        replace: true,
      });
    },
    
    updateFromPicker(color) {
      this.entity.backgroundColor = color.hex;
    },
    save() {
      let me = this;
      axios.post("company", this.entity).then((response) => {
        if (me.$route.params.id != response.data.companyId) {
          me.$router.push({
            name: "route-company-edit",
            params: { id: response.data.companyId },
          });
        }

        me.$swal({
          title: "Salvataggio avvenuto correttamente",
          text: "",
          type: "success",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });
      });
    },
  },
};
</script>
